module.exports = __webpack_public_path__ + "img/card.c36b7450.png";